"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const keautils_1 = require("keautils");
/**Codifica el valor de un query parameter*/
function encodeUrlParameterValue(parameter) {
    const str = (typeof (parameter) == "number") ? "" + parameter :
        (typeof (parameter) == "boolean") ? "" + parameter :
            (typeof (parameter) == "string") ? parameter :
                (keautils_1.toIsoDate(parameter));
    return encodeURIComponent(str);
}
exports.encodeUrlParameterValue = encodeUrlParameterValue;
/**Convierte un UrlParameters a un arreglo de key-values  */
function urlParamsToKeyValuePair(urlParameters) {
    //Aplanamos los key values que sean arreglos:
    const keyValues = Object
        .keys(urlParameters)
        //Extraemos las claves y los valores
        .map(x => ({ key: x, value: urlParameters[x] }))
        //Todos los dejamos como arreglo o si no, en un arreglo de un elemento
        .map(x => ({ key: x.key, array: Array.isArray(x.value) ? x.value : [x.value] }))
        //Creamos key values repetidos por cada value en el arreglo
        .map(x => x.array.map(y => ({ key: x.key, value: y })))
        .reduce((a, b) => a.concat(b), [])
        .filter(x => x.value != null)
        .map(x => ({ key: x.key, value: x.value }));
    return keyValues;
}
/**Devuelve una cadena con todos los parametros url, separador por &. El caracter ? inicial no se devuelve por esta función. Si no hay ningun
 * parámetro que devolver se devuelve una cadena vacia
 */
function encodeUrlParameters(urlParameters) {
    const keyValues = urlParamsToKeyValuePair(urlParameters);
    const paramsStr = keyValues.filter(x => x.value != null).map(x => x.key + "=" + encodeUrlParameterValue(x.value)).join("&");
    return paramsStr;
}
exports.encodeUrlParameters = encodeUrlParameters;
/**
 * Pega los parametros ya codificados a una URL con el separador ?. Si parameters esta vacio devuelve la URL original tal cual
 */
function appendEncodedUrlParameters(url, paramStr) {
    return paramStr ? (url + "?" + paramStr) : url;
}
exports.appendEncodedUrlParameters = appendEncodedUrlParameters;
//# sourceMappingURL=url.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kea-resource/dist/http/url.js
// module id = 518
// module chunks = 0